import React from 'react';
import VendorDashboard from './VendorDashboard';

export default function VendorMain({ onLogout }) {
    // We removed the logic that checks for "Profile Completed".
    // Vendors now go directly to the Dashboard.
    
    return (
        <VendorDashboard onLogout={onLogout} />
    );
}